<template>
  <div class="patient-routine">
    <transition
      :name="effect"
      mode="out-in"
    >
      <orders-main-filter v-if="isOrderFilterShowing" />
      <patient-routine-view v-else />
    </transition>
  </div>
</template>

<script>
import OrdersMainFilter from '@/components/Orders/OrdersMainFilter'
import PatientRoutineView from './PatientRoutineView'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PatientRoutine',
  components: {
    'orders-main-filter': OrdersMainFilter,
    'patient-routine-view': PatientRoutineView
  },
  data: () => ({
    effect: 'slide-fade'
  }),
  computed: {
    ...mapGetters(['isOrderFilterShowing', 'duplicatedOrdersFromXml', 'uploadStatus'])
  },
  watch: {
    isOrderFilterShowing: function (newVal) {
      if (newVal) {
        this.effect = 'leave-fade'
      } else {
        this.effect = 'slide-fade'
      }
    },
    $route(to, from) {
      this.setOrderShowOff(false)
    },
    uploadStatus: function (newValue) {
      if (
        newValue === 'STATUS_SUCCESS' &&
        this.duplicatedOrdersFromXml.length === 0
      ) {
        this.clearAllOrderData()
      }
    }
  },
  mounted() {
    this.orderPatientRoutine(true)
  },
  beforeDestroy() {
    this.orderPatientRoutine(false)
  },
  methods: {
    ...mapActions(['orderPatientRoutine', 'setOrderShowOff', 'clearAllOrderData'])
  },
}
</script>

<style lang="scss" scoped>
@import "../../../static/stylesheets/variables";
@import "../../../static/stylesheets/components/orders/empty-cart";

.patient-routine {
  height: 100%;

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter {
    transform: translateY(300px);
    opacity: 0;
  }

  .slide-fade-leave-to {
    transform: translateY(-400px);
    opacity: 0;
  }

  .leave-fade-enter-active {
    transition: all 0.3s ease;
  }

  .leave-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .leave-fade-enter {
    transform: translateY(-450px);
    opacity: 0;
  }

  .leave-fade-leave-to {
    transform: translateY(450px);
    opacity: 0;
  }

  .alternative-subheader {
    position: initial !important;
  }
}
</style>
